<template>
  <div class="container">
    <div class="panel1">
    </div>

    <div class="panel2">
      <div class="content">
        <h1 class="text-center">Welcome!</h1>

        <input class="form-input" type="email" v-model="email" placeholder="Email" @keyup.enter="login" />
        <input v-if="!forgot" class="form-input" type="password" v-model="password" placeholder="Password" @keyup.enter="login" />

        <button v-if="!forgot" class="btn btn-primary btn-block" @click="login" :class="{loading: loading}">Sign In</button>
        <button v-else class="btn btn-primary btn-block" @click="reset" :class="{loading: loading}">
          Reset password
        </button>

        <button class="btn btn-link btn-block" @click="forgot = !forgot; error = ''">
          {{forgot ? 'Back' : 'Forgot password?'}}
        </button>

        <div v-if="error" class="toast toast-error" style="margin-top:10px;">
          <div class="text-center">{{error}}</div>
        </div>

        <div v-if="msg" class="toast toast-success" style="margin-top:10px;">
          <div class="text-center">{{msg}}</div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'login',
  data () {
    return {
      verified: false,
      loading: false,
      forgot: false,
      email: '',
      password: '',
      error: '',
      msg: ''
    }
  },
  methods: {
    login: function () {
      this.msg = ''
      this.loading = true
      axios.post('/api/users/login', {
        email: this.email,
        password: this.password
      })
      .then(res => {
        if (res.status === 200) {
          this.loading = false
          this.error = ''
          this.$root.$data.user = res.data
          this.$root.$data.validated = true
          this.$root.$data.admin = parseInt(res.data.level) < 5

          if (!this.$root.$data.admin) {
            this.$root.getClientMatters()
          }
        }
      })
      .catch(e => {
        this.error = e.response.data
        this.$root.$data.validated = false
        this.loading = false
      })
    },
    reset: function () {
      let email = this.email.trim()
      if (!email) return
      this.loading = true
      axios.post('/api/users/sendreset/' + email)
      .then(res => {
        if (res.status === 200) {
          this.loading = false
          this.forgot = false
          this.error = ''
          this.msg = 'A password reset link has been sent to your email'
        }
      }).catch(e => {
        this.error = e.response.data
        this.loading = false
        this.msg = ''
      })
    }
  }
}
</script>

<style scoped>
.panel1 {
  background: url(../../assets/pocketlegal.png) center center no-repeat #136efb;
  background-size: 50%;
  width: 30%;
  height: 100%;
  position: fixed;
}
.panel2 {
  position: fixed;
  width: 70%;
  left: 30%;
  height: 100%
}
.content {
  width: 60%;
  max-width: 350px;
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  height: 40%;
  left: 0;
  right: 0;
}
h1 {
  font-size: 2em;
  padding: 0 0 1.2em 0;
  background: none
}
.form-input {
  border: none;
  border-radius: 0;
  border-bottom: 1px solid #136dfb;
  background: none;

}
.form-input:not(:placeholder-shown):invalid {
/* color: #fff;
border: inherit*/
}
input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus
input:-webkit-autofill, 
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
/*  border: inherit;
-webkit-text-fill-color: #fff;
-webkit-box-shadow: 0 0 0px 1000px #0c5b9c inset;
transition: background-color 5000s ease-in-out 0s;
border-bottom: 1px solid rgba(255,255,255,0.4);*/
}
.btn.btn-primary {
  height: 55px;
  margin: 1em 0 0 0
}


@media (max-width: 768px) {
  .panel1 {
    background-size: 40%;
    width: 100%;
    height: 20%;
  }
  .panel2 {
    position: fixed;
    width: 100%;
    left: 0;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// login.vue?53ef139c